import { jsx as _jsx } from "react/jsx-runtime";
/**
 * MessageSquare icon component for the Basic Comment action type in selectors and lists.
 */
import { MessageSquare } from "lucide-react";
/**
 * Icon for the basic comment step type.
 * Uses the MessageSquare icon from lucide-react.
 * @param root0 - The component props
 * @param root0.className - CSS class name for styling
 * @returns The MessageSquare icon
 */
export function Icon({ className }) {
    return _jsx(MessageSquare, { className: className });
}
//# sourceMappingURL=Icon.js.map